import KitLog from "../KitLog";
import {JsonData} from "@/Fwk/Kit/JsonData";

export class AdjustAttr {

    public static KeyAdid = "adid";
    // public static KeyMessage = "message";
    public static KeyNetwork = "network";
    public static KeyAdgroup = "adgroup";
    public static KeyCampaign = "campaign";
    public static KeyCreative = "creative";
    // public static KeyWillRetry = "willRetry";
    // public static KeyTimestamp = "timestamp";
    // public static KeyCallbackId = "callbackId";
    // public static KeyEventToken = "eventToken";
    public static KeyClickLabel = "clickLabel";
    public static KeyTrackerName = "trackerName";
    public static KeyTrackerToken = "trackerToken";
    // public static KeyJsonResponse = "jsonResponse";
    public static KeyCostType = "costType";
    public static KeyCostAmount = "costAmount";
    public static KeyCostCurrency = "costCurrency";
    public static KeyFbInstallReferrer = "fbInstallReferrer";
    // public static KeySkadConversionValue = "fineValue";
    // public static KeySkadCoarseValue = "coarseValue";
    // public static KeySkadLockWindow = "lockWindow";
    // public static KeyCode = "code";
    // public static KeyVerificationStatus = "verificationStatus";

    public adid: string | null = null;
    public network: string | null = null;
    public adgroup: string | null = null;
    public campaign: string | null = null;
    public creative: string | null = null;
    public clickLabel: string | null = null;
    public trackerName: string | null = null;
    public trackerToken: string | null = null;
    public costType: string | null = null;
    public costAmount: number = 0;
    public costCurrency: string | null = null;
    // Android only
    public fbInstallReferrer: string | null = null;

    constructor(jsonString: string) {
        let jsonNode: JsonData;
        try {
            jsonNode = new JsonData(null, jsonString);
        } catch (e) {
            if (KitLog.IsLog) KitLog.Log(`[Adjust] 归因回调,数据解析失败:${e},Web返回数据:${jsonString}`);
            jsonNode = new JsonData();
        }

        this.trackerName = jsonNode.OptString(AdjustAttr.KeyTrackerName) ?? null;
        this.trackerToken = jsonNode.OptString(AdjustAttr.KeyTrackerToken) ?? null;
        this.network = jsonNode.OptString(AdjustAttr.KeyNetwork) ?? null;
        this.campaign = jsonNode.OptString(AdjustAttr.KeyCampaign) ?? null;
        this.adgroup = jsonNode.OptString(AdjustAttr.KeyAdgroup) ?? null;
        this.creative = jsonNode.OptString(AdjustAttr.KeyCreative) ?? null;
        this.clickLabel = jsonNode.OptString(AdjustAttr.KeyClickLabel) ?? null;
        this.adid = jsonNode.OptString(AdjustAttr.KeyAdid) ?? null;
        this.costType = jsonNode.OptString(AdjustAttr.KeyCostType) ?? null;
        const value = jsonNode.OptString(AdjustAttr.KeyCostAmount);
        if (value != null) {
            this.costAmount = jsonNode.OptInt(AdjustAttr.KeyCostAmount, 0);
        }

        this.costCurrency = jsonNode.OptString(AdjustAttr.KeyCostCurrency);
        this.fbInstallReferrer = jsonNode.OptString(AdjustAttr.KeyFbInstallReferrer);
    }
}
